import { mapActions, mapState } from 'pinia';
import { useOrdersStore } from '@store';
import { Analytics } from '@segment/analytics-node';
import { isSeller, isAgent } from '@helpers/user';
import { runAsPublic } from '@helpers/api-helper';

const SEGMENT_ACTIONS = Object.freeze({
    REGISTER: 'sign-up',
    LOGIN: 'login'
});

export default {
    data: () => ({
        analytics: window.env.SEGMENT_WRITE_KEY ? new Analytics({
            writeKey: window.env.SEGMENT_WRITE_KEY
        }) : null
    }),
    computed: {
        segmentActions(){
            return SEGMENT_ACTIONS;
        },
        ...mapState(useOrdersStore, {
            getAllAssociatedOrdersSeller: 'getAllAssociatedOrders',
            getSelectedOrderFromStore: 'getSelectedOrder',
        }),
    },
    methods:{
        ...mapActions(useOrdersStore, {
            fetchOrdersToStoreAsSeller: 'fetchMyOrdersAsSeller',
            fetchOrderToStoreByUuid: 'fetchOrderUsingUuid',
            setSelectedOrderByUuid: 'setSelectedOrderDetailsByUuid',
        }),
        async segmentCapture(user, action, orderUuid = null) {
            try {
                if(!this.analytics) {
                    return;
                }
                if(isSeller(user)) {
                    await this.segmentCaptureSeller(user, action, orderUuid);
                }else if(isAgent(user)) {
                    await this.segmentCaptureAgent(user, action)
                }
            } catch(e) {
                console.error(`Error running segmentCapture [${user}, ${action}, ${orderUuid}]: ${e}`);
            }
        },
        async segmentCaptureAgent(user, action) {
            if(!this.analytics) {
                return;
            }
            let userApp = user;
            await runAsPublic(async()=>{
                await userApp.find(['broker','state', 'licenses', 'nrds']);
            });
            let license = null;
            if(userApp.licenses) {
                license = userApp.licenses.toArray().find(l => {
                    return l.stateId == userApp.stateId
                });
            }

            if(!license && userApp.nrds){

                license = userApp.nrds.toArray().find(l => {
                    return l.stateId == userApp.stateId
                }); 
            }

            let payload = {
                traits:{
                    action: `${action}`,
                    first_name: `${userApp.firstName ?? ''}`,
                    last_name: `${userApp.lastName ?? ''}`,
                    email: `${userApp.email ?? ''}`,
                    plan: `${userApp.isPremiumAgent? 'Premium' : 'Basic'}`,
                    initially_set_password: `${userApp.onboardingCompletedAt ?? userApp.createdAt ?? ''}`,
                    referring_platform: `${userApp?.referringPlatform?.display_name ?? ''}`,
                    state: `${userApp.state.title}`,
                    current_broker: `${userApp?.broker?.companyName ?? ''}`,
                    license_id: `${license?.number ?? ''}`,
                    account_type: `agent`,
                    platform: `3.0`
                },
                userId: `${userApp.uuid}`
            }
            this.analytics.identify(payload);
        },
        async segmentCaptureSeller(user, action, orderUuid = null){
            if(!this.analytics) {
                return;
            }
            const createPayload = (op) => {
                return {
                    traits: {
                        action: `${action}`,
                        first_name: `${user.firstName ?? ''}`,
                        last_name: `${user.lastName ?? ''}`,
                        email: `${user.email ?? ''}`,
                        property_address: `${op?.property?.streetAddress ?? ''}`,
                        property_city: `${op?.property?.city ?? ''}`,
                        state: `${op?.property?.state?. title ?? ''}`,
                        property_zip: `${op?.property?.zip ?? ''}`,
                        no_of_forms: `${op.forms.toArray().length}`,
                        current_broker: `${op?.broker?.companyName ?? ''}`,
                        agent: `${op?.agent?.firstName ?? ''} ${op?.agent?.lastName ?? ''}`,
                        account_type: `seller`,
                        platform: `3.0`
                    },
                    userId: `${op.uuid}`
                };
            }
            if(!orderUuid) {
                await this.fetchOrdersToStoreAsSeller(user.uuid);
                await this.getAllAssociatedOrdersSeller.forEach(async o => {
                    let payload = createPayload(o);     
                    await this.analytics.identify(payload);
                })
            } else {
                await this.fetchOrderToStoreByUuid(orderUuid);
                await this.setSelectedOrderByUuid(orderUuid);
                let payload = createPayload(this.getSelectedOrderFromStore);      
                await this.analytics.identify(payload);
            }

        }
    }
};
